// extracted by mini-css-extract-plugin
export default {"modal":"eN-z","modalOverlay":"fN-z","outfitHeading":"gN-z"};